import React, { FunctionComponent, useMemo } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

export type MainImageProps = {
  image: GatsbyImageProps['image'];
  alt: string;
  hotspot?: {
    x?: number;
    y?: number;
  };
};

const useStyles = () => {
  const { spacing, boxShadow } = useTheme();
  return {
    root: {
      borderRadius: spacing(2),
      boxShadow: boxShadow('shadow', 2),
      marginBottom: spacing(1),
    },
  };
};

const MainImage: FunctionComponent<MainImageProps> = (props) => {
  const { image, alt, hotspot } = props;
  const classes = useStyles();

  const imgStyle = useMemo(() => {
    const { x, y } = hotspot || {};
    if (typeof x === 'number' && typeof y === 'number') {
      return { objectPosition: `${x * 100}% ${y * 100}%` };
    }
  }, [hotspot]);

  return <GatsbyImage loading="eager" css={classes.root} alt={alt} imgStyle={imgStyle} image={image} />;
};

export default MainImage;
